export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/monster-1-c8a21388954338e2b6a5380a6727f663.png";